module.exports = __webpack_public_path__ + "img/home-delivery-date-top-img_medium@2x.ac538a69.jpg";